<!--
 * @Description: 查看商机
 * @Author: mdb
 * @Date: 2022-07-01 15:31:13
 * @LastEditTime: 2023-03-13 10:54:57
 * @LastEditors: mdb
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <div class="business-status-steps" :class="{ level_5: stepsList.length === 3 }">
        <a-steps :current="statusComputed - 1">
          <a-step
            v-for="item in stepsList"
            :key="item.chanceStatus"
            :title="t(item.chanceName)"
            :description="item.updateTime"
          />
        </a-steps>
      </div>
      <CosViewContent>
        <a-tabs v-model:activeKey="activeTabs" @change="handleTabsChange">
          <a-tab-pane key="info" :tab="t('common.baseTabs')">
            <BusinessForm ref="businessFormRef" :title="t('common.baseTitle')" type="view" v-model:value="dataForm" />
          </a-tab-pane>
          <a-tab-pane key="record" :tab="t('common.followTabs')">
            <TabsClueCosFollowUp :permissionPage="permissionFollow" appId="cos_ofbu" :chanceId="queryId" />
          </a-tab-pane>
          <a-tab-pane key="logs" :tab="t('common.operationLogTabs')">
            <TabsOperationLog appId="cos_ofbu" :resourceId="queryId" tableId="FbuBusinessOperationLog" />
          </a-tab-pane>
        </a-tabs>
      </CosViewContent>
    </dc-layout-content>

    <cos-footer-button :hideOk="true">
      <SellerButton
        v-permission="'ofbu_business_edit_btn'"
        controlType="none"
        :loading="loading"
        @click="handleEdit()"
        >{{ t('btn.edit') }}</SellerButton
      >
      <a-button v-permission="'ofbu_business_write_follow_btn'" :loading="loading" @click="handleWriteFollowUp()">{{
        t('btn.writeFollow')
      }}</a-button>
      <a-popover placement="topRight" trigger="hover" color="#132043e5">
        <template #content>
          <dc-penetrate-content>
            <div class="business-status-popover">
              <a-radio-group v-model:value="status" :disabled="loading" @change="statusChange">
                <a-radio v-for="item in businessStatusEnum" :key="item.value" :value="item.value">{{
                  t(item.lang)
                }}</a-radio>
              </a-radio-group>
            </div>
          </dc-penetrate-content>
        </template>
        <a-button v-permission="'ofbu_business_status_btn'" type="primary" :loading="loading">{{
          t('btn.changeStatus')
        }}</a-button>
      </a-popover>
    </cos-footer-button>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { ref, onBeforeMount, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import TabsClueCosFollowUp from '@/components/TabsClueCosFollowUp'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import BusinessForm from './components/BusinessForm.vue'
import { businessStatusEnum } from '@/views/overseasSales/commonEnum/dataConfig'
import { businessDetails, businessStatusRecord, businessChangeStatus } from '@/api/overseasSales/chanceManage'
import { useI18n } from 'vue-i18n'
import type { FbuBusinessEditParams } from '@/typings/api/chanceManage'
const router = useRouter()
const route = useRoute()
const { t } = useI18n()

const permissionFollow = {
  edit: 'ofbu_business_follow_edit_btn',
  del: 'ofbu_business_follow_del_btn',
  comment: 'ofbu_business_follow_comment_btn'
}

interface StatusStepItem {
  chanceStatus: number
  updateTime: string
  chanceId?: string
  label?: string
}

const queryId = computed(() => route.query.id as string)
const dataForm = ref<FbuBusinessEditParams>({})

const stepsList = ref([
  { chanceName: businessStatusEnum[0].lang, chanceStatus: 1, updateTime: '' },
  { chanceName: businessStatusEnum[1].lang, chanceStatus: 2, updateTime: '' },
  { chanceName: businessStatusEnum[2].lang, chanceStatus: 4, updateTime: '' }
])
const successStep = { chanceName: businessStatusEnum[2].lang, chanceStatus: 4, updateTime: '' }
const failStep = { chanceName: businessStatusEnum[3].lang, chanceStatus: 5, updateTime: '' }
const getStatusSteps = () => {
  businessStatusRecord(queryId.value).then((res) => {
    if (!res.data || !res.data.length) return
    const flag = status.value === 5
    stepsList.value.splice(2, 1, flag ? failStep : successStep)
    stepsList.value.forEach((item: StatusStepItem) => {
      const find = res.data.find((ele: StatusStepItem) => ele.chanceStatus === item.chanceStatus)
      if (find) item.updateTime = find.updateTime
    })
  })
}
const status = ref<number>(1)
const statusComputed = computed(() => {
  if (status.value === 4) {
    return status.value - 1
  } else if (status.value === 5) {
    return status.value - 2
  } else {
    return status.value
  }
})
const getDetails = () => {
  return new Promise((resolve) => {
    businessDetails({ id: route.query.id }).then((res) => {
      status.value = res.data.status
      dataForm.value = res.data
      resolve(res.data)
    })
  })
}
const initFn = async () => {
  await getDetails()
  getStatusSteps()
}

onBeforeMount(() => {
  initFn()
})

// 跳转编辑页面
const handleEdit = () => {
  router.push({ path: '/ofbu/business/edit', query: { id: queryId.value } })
}
// 跳转写跟进页面
const handleWriteFollowUp = () => {
  router.push({
    path: '/ofbu/followUpRecord/add',
    query: { followRefId: dataForm.value.saleChanceRefId, chanceId: dataForm.value.id, returnPath: route.fullPath }
  })
}

const businessFormRef = ref()
const loading = ref(false)
const statusChange = (e: any) => {
  loading.value = true
  const params = {
    id: queryId.value,
    status: e.target.value
  }
  businessChangeStatus(params)
    .then(async () => {
      message.success(t('business.ea2bif'))
      initFn()
    })
    .catch(() => {
      status.value = dataForm.value.status || 1
    })
    .finally(() => {
      loading.value = false
    })
}

const activeTabs = ref('info')
const handleTabsChange = (val: any) => {
  console.log(val)
}
</script>
<script lang="ts">
export default { name: 'DcCosOFbuBusinessView' }
</script>

<style lang="scss" scoped>
.business-status-steps {
  margin-bottom: 20px;
  padding: 0 250px 20px;
  border-bottom: 1px solid #ebebeb;
  &.level_5 {
    padding: 0 210px 20px;
  }
  :deep(.ant-steps-horizontal) {
    .ant-steps-item-title {
      font-size: 14px;
    }
    &:not(.ant-steps-label-vertical) .ant-steps-item-description {
      max-width: 100%;
      font-size: 12px;
    }
  }
}
.ant-tabs {
  overflow: visible;
}
.business-status-popover {
  .ant-radio-group {
    padding: 4px 10px;
    border-radius: 4px;
    background-color: #fff;
  }
  .ant-radio-wrapper {
    color: #666;
  }
}
</style>
